/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {tokens} from '@packages/utilities/styled';
import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const CloseCircleRedIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="CloseCircleRedIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M7.79287 7.50004L5.64642 9.64648L6.35353 10.3536L8.49998 8.20714L10.6464 10.3536L11.3535 9.64648L9.20708 7.50004L11.3535 5.35359L10.6464 4.64648L8.49998 6.79293L6.35353 4.64648L5.64642 5.35359L7.79287 7.50004Z"
            fill={tokens.colors.redText}
          />
          <path
            opacity="0.4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.5 2C5.46243 2 3 4.46243 3 7.5C3 10.5376 5.46243 13 8.5 13C11.5376 13 14 10.5376 14 7.5C14 4.46243 11.5376 2 8.5 2ZM2 7.5C2 3.91015 4.91015 1 8.5 1C12.0899 1 15 3.91015 15 7.5C15 11.0899 12.0899 14 8.5 14C4.91015 14 2 11.0899 2 7.5Z"
            fill={tokens.colors.redText}
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

CloseCircleRedIcon.tags = ['button', 'x', 'cancel', 'dismiss', 'no'];

CloseCircleRedIcon.category = 'General Icons';

CloseCircleRedIcon.iconSize = 16;
